import { Layout } from 'src/components/layout/layout';
import Component from 'src/components/MigrateFeed';


const Coupons = () => {
    return <Layout>
        <Component />
    </Layout>;
};

export default Coupons;
